import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const Swal;

@Component({
  selector: 'g10-manage-group',
  templateUrl: './manage-group.component.html',
  styleUrls: ['./manage-group.component.css']
})
export class ManageGroupComponent implements OnInit {

  public userData;

  public manageGroupData = [];
  public filteredData = [];
  public tableData = [];
  public tableOrginalData = [];
  public editEmailObj={};

  public searchForm:FormGroup;
  public manageGroupID;
  public filterEnable:boolean=false;
  public enableTable:boolean=false;         //false;

  public enableAddForm:boolean = false;
  public addFormType = '';
  
  public enableGroupVerification:boolean = false;
  public editManageData:any;

  constructor(public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public fb: FormBuilder) { 
      this.userData = this.storage.get('userInfo')
  }

  ngOnInit(): void {
    this.searchFormLoad();
    this.tableData = [ ...this.manageGroupData];
    this.getManageGroupData();
    //setTimeout(()=>{ this.fieldChange(); },500); 
  }

  searchFormLoad(){
    this.searchForm=this.fb.group({
      groupName:[''],
      type:[''],
    });
  }
  
  fieldChange(){
    this.filteredData = [ ...this.tableOrginalData];
    this.tableData = [ ...this.tableOrginalData];
    console.log(this.searchForm,'searchForm');
    Object.entries(this.searchForm.value).forEach(([key, value]) => {
      if (value)  this.filterGroup(key,value);  });
  }

  filterGroup(key,value){
      if (key=='groupName' || key =='type'){
        this.filteredData = this.filteredData.filter((e)=>{
          let groupTitle = e[key].toLowerCase();
          if(groupTitle.search(value.toLowerCase()) !=-1 )
            return e;   
          });
      }
     /*  if (key=='type'){
        this.filteredData = this.filteredData.filter((e)=>{
          if(e[key].toLowerCase().search(value.toLowerCase()) != -1) return e;  });
      } */
    this.tableData = [ ...this.filteredData];
  }
  resetFilter(){
    this.tableData = [ ...this.tableOrginalData];
  }

  editManageGroupData(element){
    this.manageGroupID=element.manageGroupID;
    console.log(element);
    this.editManageData = element;
    //this.patchEmailValue(element)
    this.enableGroupVerification = true;
  }
  closeEditModal(event){
    this.enableGroupVerification = event;  // false
    this.getManageGroupData();
  }
  closeAddModal(event){
    this.enableAddForm = event;
    this.getManageGroupData();
  }

/* get email data*/
  getManageGroupData() {
    const obj = {
      orgID: this.userData.orgID,
    }; 
    this.api.transportManagerManageGroupList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.manageGroupData = res.data;
        this.setManageTableData(res.data);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  setManageTableData(data){
    this.enableTable = false;
    this.filteredData = [];
    this.tableData = [];
    let uniqueGrpName = [];
    this.tableOrginalData = [];
    data.filter((element)=>{
      if(uniqueGrpName.indexOf(element.groupName) == -1) uniqueGrpName.push(element.groupName);
    });
    setTimeout(()=>{
      uniqueGrpName.filter((grpName)=>{
        let obj = {
          groupName:grpName,
          type:'',
          verified:0,
          status:1,
        }
        data.filter((element)=>{
          if(element.groupName == grpName){
            obj.type = element.type;
            if(element.verify) obj.verified++;
            obj.status = element.status;
            if(obj[obj.type]==undefined) obj[obj.type] = [];
            obj[obj.type].push(element);
          }
        });
        this.tableData.push(obj);
        this.filteredData.push(obj);
        this.tableOrginalData.push(obj);
      })
    },200);
    setTimeout(()=>{ this.enableTable = true; },500);

  }

  addForm(type){
    this.enableAddForm = false;
    this.addFormType = type;
    this.enableAddForm = true;
  }

  //update status

  updateStatus(data,index){

    let status = data.status;
    console.log(status,status == '0');
    if(status == '0') status = '1';
    else status = '0';

    let obj = {
      manageGroupID:this.manageGroupID,
      status:Number(status),
    };
    
    this.api.transportManagerManageGroupUpdate(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        setTimeout(()=>{
          this.getManageGroupData();
        },2500);
      } else {
        this.swal.swalFunction('error', res.status, res.message, 2000);
      }
    });

  }

  delete(data) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor:  '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('delete click');
        this.deleteEmail(data);
        /* Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        ); */
      }
    });
  }
  deleteEmail(data){
    let obj={
      groupID:data.groupID,
      groupName:data.groupName,
    }
    console.log(obj,data);
    this.api.transportManagerManageGroupDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.getManageGroupData();
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

}
